import { render } from "./AllowListView.vue?vue&type=template&id=3dcf8fa1"
import script from "./AllowListView.vue?vue&type=script&lang=js"
export * from "./AllowListView.vue?vue&type=script&lang=js"

import "./AllowListView.vue?vue&type=style&index=0&id=3dcf8fa1&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__